import React from 'react'
import {
  Modal,
  Typography,
  IconButton,
  TextField,
  Button,
  AppBar,
  Tab,
  Tabs,
  Table,
  TableCell,
  TableBody,
  TableRow,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core'
import './ReservationAdditionalFields.scss'
import FieldTypeLookup from './FieldTypeLookup.json'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CloseIcon from '@material-ui/icons/Close'
import _ from 'lodash'
import FieldTypeRequiredFields from './FieldTypeRequiredFields'
import Select from '../ReservationComponents/Select'
import Cookies from 'js-cookie'
import {removeReservationFilters} from '../../services/reservations/reservationConfiguration'

const RootClass = 'mod-reservation-additional-fields'

const ReservationAdditionalFields = ({
  data = {},
  edit = false,
  open = false,
  onClose = () => {},
  entity_id = {},
  onSave = (e, data) => {},
}) => {
  const [field, setField] = React.useState({
    name: '',
    type: '',
    is_required: false,
    is_open_field: true,
    is_system: true,
  })
  const handleChangeName = e => {
    setField({...field, name: e.target.value})
  }
  const handleChangeType = (e, data) => {
    if (data === 'DateField' || data === 'DateTimeField') {
      setField({
        name: field.name,
        is_required: false,
        is_open_field: true,
        is_system: true,
        type: data,
        default_value: {
          value: 'none',
          op: 'add',
          days: 0,
          months: 0,
          years: 0,
        },
        selection_limits: 'disabled',
        selection_limits_minimum: {
          value: 'none',
          op: 'add',
          days: 0,
          months: 0,
          years: 0,
        },
        selection_limits_maximum: {
          value: 'none',
          op: 'add',
          days: 0,
          months: 0,
          years: 0,
        },
      })
    } else {
      setField({
        name: field.name,
        is_required: false,
        is_open_field: true,
        is_system: true,
        type: data,
      })
    }
  }

  const handleClickRequired = e => {
    setField({...field, is_required: !field.is_required})
  }

  const handleSave = async e => {
    Cookies.set('isApplied', 'true')
    const value_data_id = data.id
    if (Cookies.get('filters_removed_' + value_data_id)) {
      try {
        if (field.list_filters_attributes) {
          const deletedFilterIds = Object.values(field.list_filters_attributes)
            .filter(filter => filter._destroy === 'true')
            .map(filter => filter.id)

          const apiPayload = {
            entity_id: entity_id,
            field_id: field.id,
            deleted_filters: deletedFilterIds,
          }
          const response = await removeReservationFilters(apiPayload)
          Cookies.set('removed_filter_savedResponse_' + value_data_id, response)
        }
      } catch (error) {
        console.error('Error removing reservation filters:', error)
      }
    }

    onSave(e, {...field})
    setField({
      name: '',
      type: '',
      is_required: false,
      is_open_field: true,
      is_system: true,
    })
  }

  const handleClose = e => {
    const value_data = data.id
    Cookies.remove('filters_removed_' + value_data)
    Cookies.set('isApplied', 'false')
    Cookies.set('isChanged', 'false')
    onClose()
    setField({
      name: '',
      type: '',
      is_required: false,
      is_open_field: true,
      is_system: true,
    })
  }

  const handleChangeRequiredFieldData = (
    e,
    key,
    value = null,
    subkey = null,
    index = null,
    data = null,
    typeId = null
  ) => {
    // eslint-disable-next-line
    if (e == 'fieldRemove') {
      let existing = field[key]
      if (data) {
        setField({
          ...field,
          [key]: {
            ...existing,
            [index]: {
              id: data.id,
              field_id: data.field_id,
              _destroy: 'true',
              invert_query: data.invert_query,
              fix_value: data.fix_value,
            },
          },
        })
      } else {
        if (existing) {
          delete existing[index]
          setField(field)
        }
      }
    } else if (e === 'remove') {
      let existing = field[key]
      if (data) {
        delete existing[data.id]
        setField({
          ...field,
          [key]: {
            ...existing,
            [index]: {
              id: data.id,
              field_id: data.field_id,
              _destroy: 'true',
              invert_query: data.invert_query,
              fix_value: data.fix_value,
            },
          },
        })
      } else {
        if (existing) {
          delete existing[index]
          setField(field)
        }
      }
    } else if (key === 'template_filters_attributes' && index >= 0) {
      let existing = field[key]
      setField({
        ...field,
        [key]: {
          ...existing,
          [index]: {
            id: '',
            field_id: '',
            _destroy: 'false',
            invert_query: '',
            fix_value: [],
            ..._.get(existing, `${[index]}`),
            [subkey]: value,
          },
        },
      })
      // Add filter for GroupList
    } else if (key === 'list_filters_attributes' && index >= 0) {
      let existing = field[key]
      setField({
        ...field,
        [key]: {
          ...existing,
          [index]: {
            id: '',
            field_id: typeId,
            _destroy: 'false',
            invert_query: '',
            fix_value: [],
            ..._.get(existing, `${[index]}`),
            [subkey]: value,
          },
        },
      })
    } else if (subkey) {
      let existing = field[key]
      setField({...field, [key]: {...existing, [subkey]: e.target.value}})
    } else if (value) {
      setField({...field, [key]: value})
    } else {
      setField({...field, [key]: e.target.value})
    }
  }

  React.useEffect(() => {
    if (!_.isEmpty(data)) {
      setField({
        ...data,
      })
    }
    //eslint-disable-nextline
  }, [data])

  return (
    <Modal
      style={{position: 'absolute'}}
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div className={`modal-view ${RootClass}`}>
        <div className="modal-view__header">
          <Typography className="modal-view__title">
            {edit ? 'Edit Field' : 'Add New Field'}
          </Typography>
          <IconButton onClick={handleClose} className="modal-view__btn-x">
            <CloseIcon />
          </IconButton>
        </div>
        <div className="modal-view__body ap-scrollbar" style={{height: '64vh'}}>
          <div>
            <div>
              <TextField
                variant="outlined"
                className="ap-textfield"
                label="Name"
                value={field.name}
                onChange={handleChangeName}
                style={{width: 200, marginTop: 16}}
              />
            </div>
            <div>
              <Select
                label="Type"
                value={field.type}
                onChange={handleChangeType}
                options={_.map(FieldTypeLookup, (f, i) => ({label: f, value: i}))}
                renderSelected={(options, value) => options.find(o => o.value === value)?.label}
                renderOption={v => v.label}
                returnValue={v => v.value}
              />
            </div>
            <div>
              <FieldTypeRequiredFields
                type={field.type}
                data={field}
                setData={setField}
                entity_id={entity_id}
                onChange={handleChangeRequiredFieldData}
              />
            </div>
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    name="required"
                    size="small"
                    checkedIcon={<CheckCircleIcon style={{color: '#3473ff'}} />}
                    checked={field.is_required || false}
                    onClick={handleClickRequired}
                  />
                }
                label="Required"
              />
            </div>
          </div>
        </div>
        <div className="modal-view__footer">
          <div className="modal-view__container modal-view__container--right">
            <Button
              disabled={
                field.type === 'DateDurationField'
                  ? !field.name ||
                    !field.type ||
                    !field?.duration_end?.id ||
                    !field?.duration_start?.id
                  : !field.name || !field.type
              }
              onClick={handleSave}
              style={{width: 96}}
              className="modal-view__btn-primary"
            >
              Apply
            </Button>
            <Button onClick={handleClose} style={{width: 96}} className="modal-view__btn-outlined">
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
export default ReservationAdditionalFields
